import React from 'react';
import { useQuery } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useAuth } from '~/context/auth';
import { GROUP_STATISTICS } from '~/data/operations/group';
import { YearbookStackParamList } from '~/navigation/types';
import BookStatisticsLayout from './layout';

type BookStatisticsNavProp = StackNavigationProp<
  YearbookStackParamList,
  'BookStatistics'
>;

export default function BookStatistics({ now }: { now?: Date }): JSX.Element {
  const navigation = useNavigation<BookStatisticsNavProp>();

  const { authGroupId } = useAuth();

  const { data: groupStatisticsData } = useQuery(GROUP_STATISTICS, {
    variables: {
      id: authGroupId,
    },
  });

  const groupStatistics = groupStatisticsData?.group;
  return (
    <BookStatisticsLayout
      groupStatistics={groupStatistics}
      now={now}
      onBack={() => navigation.goBack()}
    />
  );
}
